import React from 'react';
import UserList from '../UserList';

const UserListDetails = () => {
    
    return (
        <>
         <main className='main'>
        
        <div className="page-title dark-background aos-init aos-animate" data-aos="fade" >
        <div className="container position-relative">
            <h1>UserList Details</h1>
            <p>Esse dolorum voluptatum ullam est sint nemo et est ipsa porro placeat quibusdam quia assumenda numquam molestias.</p>
            <nav className="breadcrumbs">
            <ol>
                <li><a href="index.html">Home</a></li>
                <li className="current">About</li>
            </ol>
            </nav>
        </div>
        </div>
        <section id="about" className="about section">
        <div className="container">
        <div className="row gy-4">
        <UserList></UserList>
        </div>
        </div>

        </section>
            

        </main>
        </>
    );
};
export default UserListDetails;